const AssetStatusEnum = Object.freeze({
    EN_FONDEO: 'investment_commitment',
    VIGENTE: 'collecting',
    OTROS_BIENES_ADMINISTRACION: 'assets_under_management',
    BIENES_MANDATO: 'assets_in_mandate',
    PAGADO: 'settled',
    QUEBRANTADO_PARCIALMENTE: 'partial_default',
    IRRECUPERABLE: 'irrecoverable'
  });
  export default AssetStatusEnum;